// extracted by mini-css-extract-plugin
module.exports = {"button":"profile-logout_button__wQGri","buttonText":"profile-logout_buttonText__llCH_","buttonIcon":"profile-logout_buttonIcon__9nb8M"};